import React, { CSSProperties, FC, useState } from "react";
import { QRCodeSVG } from "qrcode.react";

// MUI
import { IconButton, SxProps, TextField } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import Check from "@mui/icons-material/Check";

// Type
export interface IShareLinkProps {
  value: string;
}

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  } as CSSProperties,
  textField: { width: "98%" } as SxProps,
  qrCode: { margin: "10px" } as CSSProperties,
};

const ShareLink: FC<IShareLinkProps> = (props) => {
  const [isCopied, setIsCopied] = useState(false);
  const { value } = props;

  const handleCopyClick = () => {
    const textField = document.createElement("textarea");
    textField.value = value;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand("copy");
    document.body.removeChild(textField);
    setIsCopied(true);
  };
  return (
    <div style={styles.container}>
      <TextField
        variant="outlined"
        fullWidth
        value={value}
        onFocus={(event) => {
          event.target.select();
        }}
        sx={styles.textField}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <IconButton
              onClick={handleCopyClick}
              disabled={isCopied}
              edge="end"
            >
              {isCopied ? <Check sx={{ color: "green" }} /> : <ContentCopy />}
            </IconButton>
          ),
        }}
      />
      <QRCodeSVG value={value} style={styles.qrCode} />
    </div>
  );
};

export default ShareLink;
